import axiosInstance from '../axiosInstance.js'

export default {
  /**
   * login
   *
   * @typedef {Object} credentialsPayload = { username, password }
   * @returns {Object}
   */
  login(credentialsPayload) {
    return axiosInstance.post(
      '/login_check',
      JSON.stringify(credentialsPayload)
    )
  },

  refreshToken(refresh_token) {
    return axiosInstance.post(
      '/token/refresh',
      JSON.stringify({
        refresh_token: refresh_token
      })
    )
  }
}
